import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import API_BASE from "../config/api";

const studentData = [
  {
    name: "आर्यन राजन देशमुख",
    exam: "मराठी",
    marks: 3,
    status: "सक्रिय",
  },
  {
    name: "सिद्धार्थ विजय जोशी",
    exam: "गणित",
    marks: 9,
    status: "सक्रिय",
  },
  {
    name: "सान्वी प्रकाश कुलकर्णी",
    exam: "बुद्धिमत्ता",
    marks: 7,
    status: "सक्रिय",
  },
  {
    name: "ओंकार महेश शिंदे",
    exam: "मराठी",
    marks: 5,
    status: "सक्रिय",
  },
];
const softwareData = [
  {
    exam: "पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा",
    price: "₹1500",
    duration: "३ महिने",
    buyDate: "10/12/2025",
    expiryDate: "10/03/2026",
  },
  {
    exam: "NMMS Exam",
    price: "₹2000",
    duration: "६ महिने",
    buyDate: "22/12/2025",
    expiryDate: "22/06/2026",
  },
];
const InstituteDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [teacherList, setTeacherList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [deleteType, setDeleteType] = useState("");
  const location = useLocation();

  const [institute, setInstitute] = useState(null);
  const [softwareList, setSoftwareList] = useState([]);

  const [deleteIndex, setDeleteIndex] = useState(null);
  const [standards, setStandards] = useState([]);
  const [softwares, setSoftwares] = useState([]);

  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [examList, setExamList] = useState([]);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "संस्था तपशील"
  );
  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setDeleteType("teacher");
    setShowDeletePopup(true);
  };

  const confirmDelete = () => {
    const updatedList = [...teacherList];
    updatedList.splice(deleteIndex, 1);
    setTeacherList(updatedList);
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };


  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };
  const handleViewClick = (teacherUserId) => {
    navigate(`/dashboard/teacherview/${teacherUserId}`);
  };
  const handleteachrEditClick = (teacherUserId) => {
    navigate(`/dashboard/teacheredit/${teacherUserId}`);
  };
  const handleEditClick = (instituteId) => {
    navigate(`/dashboard/institudeedit/${instituteId}`);
  };

  const handlestudentViewClick = (studentId) => {
    navigate(`/dashboard/studentview/${studentId}`, {
      state: {
        instituteId: id
      }
    });
  };

  const handlestudentEditClick = (studentId) => {
    navigate(`/dashboard/studentedit/${studentId}`, {
      state: {
        instituteId: id
      }
    });
  };
  const handlestudentDeleteClick = (studentId) => {
    setDeleteIndex(studentId);
    setDeleteType("student");
    setShowDeletePopup(true);
  };

  const studentconfirmDelete = () => {
    const updatedList = [...studentList];
    updatedList.splice(deleteIndex, 1);
    setStudentList(updatedList);
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };

  const studentcancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };

  const handlesoftEditClick = (InstituteSoftwareId) => {
    navigate(`/dashboard/institudesoftedit/${InstituteSoftwareId}`);
  };

  const handlesoftViewClick = (InstituteSoftwareId) => {
    navigate(`/dashboard/institudsoftview/${InstituteSoftwareId}`);
  };


  useEffect(() => {
    if (!id) return;

    axios
      .get(`${API_BASE}/api/Institutes/${id}`)
      .then(res => {
        setInstitute(res.data);
        setSoftwareList(res.data.softwares || []);
      })
      .catch(err => {
        console.error("Failed to load institute details", err);
      });
  }, [id]);

  useEffect(() => {
    if (activeTab !== "शिक्षक") return;
    if (!id) return;

    axios.get(`${API_BASE}/api/institute/teachers?`, {
      params: {
        instituteId: id,       // 👈 VERY IMPORTANT (SuperAdmin)
        pageNumber: 1,
        pageSize: 10,
        search: searchQuery || null
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(res => {
        setTeacherList(res.data.data); // PagedResponseDto → data
        console.log(res.data, 'data')
      })
      .catch(err => {
        console.error("Failed to load teachers", err);
      });

  }, [activeTab, id, searchQuery]);

  useEffect(() => {
    axios.get(`${API_BASE}/api/softwares/standards`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(res => setStandards(res.data))
      .catch(err => console.error("Failed to load standards", err));
  }, []);


  useEffect(() => {
    axios.get(`${API_BASE}/api/softwares/softwares-dropdown`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(res => setSoftwares(res.data))
      .catch(err => console.error("Failed to load softwares", err));
  }, []);



  useEffect(() => {
    if (activeTab !== "विद्यार्थी") return;
    if (!id) return;

    axios.get(`${API_BASE}/api/instituteadmin/students`, {
      params: {
        instituteId: id,          // 👈 SUPER IMPORTANT
        pageNumber: 1,
        pageSize: 10,
        search: searchQuery || null,
        standardId: selectedStandard || null,
        softwareId: selectedSoftware || null
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(res => {
        setStudentList(res.data.data); // PagedResponseDto
        console.log(res.data, 'data')
      })
      .catch(err => {
        console.error("Failed to load students", err);
      });

  }, [activeTab, id, searchQuery, selectedStandard, selectedSoftware]);

  useEffect(() => {
    if (activeTab !== "सॉफ्टवेअर") return;
    if (!id) return;

    axios.get(`${API_BASE}/api/Institutes/${id}/softwares`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
      }
    })
      .then(res => {
        setSoftwareList(res.data);
        console.log(res.data, "software list");
      })
      .catch(err => {
        console.error("Failed to load softwares", err);
      });

  }, [activeTab, id]);

  if (!institute) {
    return <div className="page-wrapper">Loading...</div>;
  }



  return (
    <div className="page-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन  &gt;&gt; तपशील &gt;&gt;{" "}
          <span>
            {activeTab === "शिक्षक"
              ? "शिक्षक माहिती"
              : activeTab === "विद्यार्थी"
                ? "विद्यार्थी माहिती"
                : activeTab === "सॉफ्टवेअर"
                  ? "सॉफ्टवेअर माहिती"
                  : "संस्था तपशील"}
          </span>


        </h3>

        {activeTab === "संस्था तपशील" && (
          <button className="edit-btn" onClick={() => handleEditClick(institute.id)}>
            एडिट करा
          </button>
        )}

      </div>

      {/* TABS */}
      <div className="tabs">
        {["संस्था तपशील", "शिक्षक", "विद्यार्थी", "सॉफ्टवेअर"].map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {activeTab === "संस्था तपशील" && (
        <div className="exam-form">
          <div className="form-group">
            <label>संस्थेचे नाव</label>
            <input value={institute.instituteName} disabled />
          </div>

          <div className="form-group">
            <label>मुख्याध्यापक नाव</label>
            <input value={institute.principleName} disabled />
          </div>

          <div className="form-group">
            <label>पत्ता</label>
            <input value={institute.address} disabled />
          </div>

          <div className="form-group">
            <label>ईमेल आयडी</label>
            <input value={institute.email} disabled />
          </div>

          <div className="form-group">
            <label>संपर्क क्रमांक</label>
            <input value={institute.phoneNumber} disabled />
          </div>

          <div className="form-group">
            <label>शिक्षकांची संख्या</label>
            <input value={institute.teachersCount} disabled />
          </div>

          <div className="form-group">
            <label>परीक्षांचे नाव</label>
            <textarea
              rows="3"
              value={institute.softwares.map((s, i) => `${i + 1}. ${s.name}`).join("\n")}
              disabled
            />
          </div>

          <div className="form-group">
            <label>कमिशन टक्केवारी</label>
            <input value={`${institute.commissionPercentage}%`} disabled />
          </div>

          <div className="form-group">
            <label>स्थिती</label>
            <input value={institute.isActive ? "सक्रिय" : "निष्क्रिय"} disabled />
          </div>

          {/* <div className="form-group">
            <label>पेमेंट कॉन्फिगरेशन</label>
            <input value="-" disabled />
          </div> */}
        </div>
      )}
      {activeTab === "शिक्षक" && (
        <div className="teacher-section">
          <div className="filters">
            <div className="search-wrapper-exam">
              <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
                <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
              <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </div>
          </div>

          {/* Teacher Table */}
          <table className="teacher-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>शिक्षक नाव</th>
                <th>नियुक्त इयत्ता</th>
                <th>परीक्षे नाव</th>
                <th>नियुक्त विषय</th>
                <th>घेतलेल्या परीक्षा संख्या</th>
                <th>स्थिती</th>
                <th>क्रिया</th>
              </tr>
            </thead>

            <tbody>
              {teacherList.map((item, index) => (

                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.teacherName}</td>
                  <td>{item.standards?.map(s => s.name).join(", ") || "-"}</td>
                  <td>{item.softwares?.map(s => s.softwareName).join(", ") || "-"}</td>
                  <td>{item.subjects?.map(s => s.name).join(", ") || "-"}</td>
                  <td>{item.examsCreatedCount}</td>
                  <td>
                    <span className={item.isActive ? "status-active" : "status-inactive"}>
                      {item.isActive ? "सक्रिय" : "निष्क्रिय"}
                    </span>
                  </td>
                  <td className="actions">
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(item.userId)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleteachrEditClick(item.userId)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(index)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M7.6155 20.0036C7.15517 20.0036 6.77083 19.8495 6.4625 19.5411C6.15417 19.2328 6 18.8485 6 18.3881V6.00363H5V5.00363H9V4.23438H15V5.00363H19V6.00363H18V18.3881C18 18.8485 17.8458 19.2328 17.5375 19.5411C17.2292 19.8495 16.8448 20.0036 16.3845 20.0036H7.6155ZM9.80775 17.0036H10.8078V8.00363H9.80775V17.0036ZM13.1923 17.0036H14.1923V8.00363H13.1923V17.0036Z" fill="#FF1501" />
                    </svg>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-box" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 32 36" fill="none">
                <path d="M6 36C4.9 36 3.95833 35.6083 3.175 34.825C2.39167 34.0417 2 33.1 2 32V6C1.43333 6 0.958333 5.80833 0.575 5.425C0.191667 5.04167 0 4.56667 0 4C0 3.43333 0.191667 2.95833 0.575 2.575C0.958333 2.19167 1.43333 2 2 2H10C10 1.43333 10.1917 0.958333 10.575 0.575C10.9583 0.191667 11.4333 0 12 0H20C20.5667 0 21.0417 0.191667 21.425 0.575C21.8083 0.958333 22 1.43333 22 2H30C30.5667 2 31.0417 2.19167 31.425 2.575C31.8083 2.95833 32 3.43333 32 4C32 4.56667 31.8083 5.04167 31.425 5.425C31.0417 5.80833 30.5667 6 30 6V32C30 33.1 29.6083 34.0417 28.825 34.825C28.0417 35.6083 27.1 36 26 36H6ZM26 6H6V32H26V6ZM12 28C12.5667 28 13.0417 27.8083 13.425 27.425C13.8083 27.0417 14 26.5667 14 26V12C14 11.4333 13.8083 10.9583 13.425 10.575C13.0417 10.1917 12.5667 10 12 10C11.4333 10 10.9583 10.1917 10.575 10.575C10.1917 10.9583 10 11.4333 10 12V26C10 26.5667 10.1917 27.0417 10.575 27.425C10.9583 27.8083 11.4333 28 12 28ZM20 28C20.5667 28 21.0417 27.8083 21.425 27.425C21.8083 27.0417 22 26.5667 22 26V12C22 11.4333 21.8083 10.9583 21.425 10.575C21.0417 10.1917 20.5667 10 20 10C19.4333 10 18.9583 10.1917 18.575 10.575C18.1917 10.9583 18 11.4333 18 12V26C18 26.5667 18.1917 27.0417 18.575 27.425C18.9583 27.8083 19.4333 28 20 28Z" fill="#FF0000" />
              </svg>
              <h3>
                {deleteType === "student" ? "विद्यार्थी हटवा" : "शिक्षक हटवा"}
              </h3>

              {/* 🔹 Dynamic Text */}
              <p>
                {deleteType === "student"
                  ? "तुम्हाला हा विद्यार्थी कायमचा हटवायचा आहे का?"
                  : "तुम्हाला हा शिक्षक कायमचा हटवायचा आहे का?"}
              </p>
            </div>
            <div className="delete-popup-buttons">
              <button className="delete-cancel-btn" onClick={cancelDelete}>नाही </button>
              <button
                className="delete-confirm-btn"
                onClick={
                  deleteType === "student"
                    ? studentconfirmDelete
                    : confirmDelete
                }
              >
                होय
              </button>            </div>
          </div>
        </div>
      )}

      {activeTab === "विद्यार्थी" && (
        <div className="student-section">

          {/* Filters */}
          <div className="filters">
            <div className="search-wrapper-exam">
              <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
                <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
              <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </div>
            <select value={selectedStandard} onChange={e => setSelectedStandard(e.target.value)}>
              <option value="">इयत्ता</option>
              {standards.map(s => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
            <select
              value={selectedSoftware}
              onChange={e => setSelectedSoftware(e.target.value)}
            >
              <option value="">परीक्षेचे नाव</option>
              {softwares.map(s => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          {/* Student Table */}
          <table className="student-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>विद्यार्थी नाव</th>
                <th>इयत्ता</th>
                <th>सरासरी गुण</th>
                <th>स्थिती</th>
                <th>क्रिया</th>
              </tr>
            </thead>

            <tbody>
              {studentList.map((item, index) => (

                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.studentName}</td>
                  <td>{item.standardName}</td>
                  <td>{item.obtainedMarks}</td>
                  {/* <td>{item.statusText}</td> */}
                  <td style={{ color: item.isActive ? "green" : "red" }}>
                    {item.isActive ? "सक्रिय" : "निष्क्रिय"}
                  </td>
                  <td className="actions">
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handlestudentViewClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handlestudentEditClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handlestudentDeleteClick(index)} width="12" height="14" viewBox="0 0 14 16" fill="none">
                      <path d="M2.6155 15.7693C2.15517 15.7693 1.77083 15.6151 1.4625 15.3068C1.15417 14.9984 1 14.6141 1 14.1538V1.76925H0V0.769251H4V0H10V0.769251H14V1.76925H13V14.1538C13 14.6141 12.8458 14.9984 12.5375 15.3068C12.2292 15.6151 11.8448 15.7693 11.3845 15.7693H2.6155ZM4.80775 12.7693H5.80775V3.76925H4.80775V12.7693ZM8.19225 12.7693H9.19225V3.76925H8.19225V12.7693Z" fill="#FF1501" />
                    </svg>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {activeTab === "सॉफ्टवेअर" && (
        <div className="software-section">
          <div className="filters">
            <div className="search-wrapper-exam">
              <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
                <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
              <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
            </div>
          </div>

          {/* Software Table */}
          <table className="software-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>परीक्षा नाव</th>
                <th>किंमत</th>
                <th>कालावधी</th>
                <th>सॉफ्टवेअर खरेदी दिनांक</th>
                <th>सॉफ्टवेअर समाप्ती दिनांक</th>
                <th>क्रिया</th>
              </tr>
            </thead>

            <tbody>
              {softwareList.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.softwareName}</td>
                  <td>{item.softwarePrice}</td>
                  <td>{item.duration}</td>
                  <td>{new Date(item.purchaseDate).toLocaleDateString("en-GB")}</td>
                  <td>{new Date(item.softwareEndDate).toLocaleDateString("en-GB")}</td>
                  <td className="actions">
                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handlesoftViewClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handlesoftEditClick(item.id)} width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5.02607 19.9157C4.74007 19.9734 4.49674 19.9019 4.29607 19.7014C4.09557 19.5008 4.02415 19.2574 4.08182 18.9714L4.72607 15.8369L8.16057 19.2714L5.02607 19.9157ZM8.92032 18.6234L5.37407 15.0772L15.7376 4.73294C16.0439 4.4266 16.4227 4.27344 16.8741 4.27344C17.3254 4.27344 17.7042 4.4266 18.0106 4.73294L19.2646 5.98694C19.5709 6.29327 19.7241 6.6721 19.7241 7.12344C19.7241 7.57477 19.5709 7.9536 19.2646 8.25994L8.92032 18.6234Z" fill="#4285F4" />
                    </svg>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      )}


    </div>
  );
};

export default InstituteDetails;
